import React, { useState, useEffect } from 'react';
import LottieAnimation from 'components/LottieAnimation';
import rocketAnimation from 'assets/animations/rocket-launcher.json';
import { RocketContainer } from './ScrollRocket.styles';

const ScrollRocket = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = scrollTop / docHeight;

      // Determine scroll direction
      let direction = 0;
      if (scrollTop > lastScrollY) {
        direction = 1;
      } else if (scrollTop < lastScrollY) {
        direction = -1;
      }
      setScrollDirection(direction);
      setLastScrollY(scrollTop);

      setScrollProgress(Math.min(Math.max(scrollPercent, 0), 1));
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  // Rotate rocket based on scroll direction: 0° pointing up, 180° pointing down
  const rotation = scrollDirection >= 0 ? 180 : 0;

  const rocketPosition = {
    top: `${20 + scrollProgress * 60}%`,
    transform: `translateY(-50%) rotate(${rotation}deg)`,
    transition: 'transform 0.3s ease-out',
  };

  return (
    <RocketContainer style={rocketPosition}>
      <LottieAnimation
        animationData={rocketAnimation}
        width="150px"
        height="200px"
        loop
        autoplay
      />
    </RocketContainer>
  );
};

export default ScrollRocket;
